import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { history } from '../store'
import { push } from 'react-router-redux'
import { withNamespaces } from "react-i18next"
import AppTimeHeader from '../containers/AppTimeHeader'
import { fetchTimeDisponibility, postTimePrebooking } from '../actions/qrstime'
import StepBarTime from '../components/StepBarTime'
import { Modal, ModalBody } from 'reactstrap'
import { Info, Package } from 'lucide-react'
import { currencySymbol } from '../utils/currency';

class LockerSelectorTimeView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      lockers: null,
      prices: null,
      customer: null,
      qrType: 'pay',
      selectedLockerType: null,
      selectedTotalMinutes: null,
      timeConfig: null,
      ticketIVA: '21',
      termsLink: 'https://vacway.com/locker-terms.html',
      errorMessage: false,
      isLoading: false,
      step: 1, // 1=select type, 2=select time
      measureModal: false,
      measureType: null,
    }
    this.timeSelectorRef = React.createRef();
  }

  getButtonStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || '#01315f';
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || '#067ddb';
    const buttonText = qrData?.headerConfig?.buttonText || '#ffffff';

    return {
      background: `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`,
      color: buttonText,
      border: 'none'
    };
  }

  getPrimaryColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.primaryColor || '#01315f';
  }

  getSecondaryColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.secondaryColor || '#067ddb';
  }

  componentDidMount() {
    const { zoneSelected, qr, timeConfig } = this.props.location.state;
    const qrtoken = qr.toString() + zoneSelected.toString();

    this.setState({ timeConfig: timeConfig });

    this.props.fetchLockers(qrtoken)
      .then((answer) => {
        const answerLockers = answer.response.answerLockers;

        // Disponibility comes back as an object keyed by Mode+Wide+Type
        // e.g. {"BNS": {Qty:3}, "BNM": {Qty:1}}
        // Keep the full key so names/images/prices all resolve correctly
        const disponibilityObj = answerLockers.Disponibility || {};
        const lockersArray = Object.entries(disponibilityObj).map(([type, val]) => ({
          type,
          available: val.Qty || 0,
        }));

        const availableTypes = lockersArray.filter(l => l.available > 0);

        this.setState({
          lockers: lockersArray,
          prices: answerLockers.Prices,
          customer: answerLockers.Customer,
          qrType: answerLockers.qrType,
          ticketIVA: answerLockers.ticketIVA || '21',
          termsLink: answerLockers.termsLink || 'https://vacway.com/locker-terms.html',
        }, () => {
          // Auto-select when only one locker type is available
          if (availableTypes.length === 1) {
            this.selectLockerType(availableTypes[0].type);
          }
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  getLockerType(type) {
    switch (type) {
      case 'BNS': return 'Standard';
      case 'CNS': return 'Standard Carga';
      case 'BWS': return 'Standard XL';
      case 'CWS': return 'Standard Carga XL';
      case 'BNM': return 'Medium';
      case 'CNM': return 'Medium Carga';
      case 'BWM': return 'Medium XL';
      case 'CWM': return 'Medium Carga XL';
      case 'BNL': return 'Large';
      case 'CNL': return 'Large Carga';
      case 'BWL': return 'Large XL';
      case 'CWL': return 'Large Carga XL';
      case 'BNXL': return 'Large';
      case 'CNXL': return 'Large Carga';
      case 'BWXL': return 'Large XL';
      case 'CWXL': return 'Large Carga XL';
      case 'BN2XL': return 'Large';
      case 'CN2XL': return 'Large Carga';
      case 'BW2XL': return 'Large XL';
      case 'CW2XL': return 'Large Carga XL';
      case 'BN3XL': return 'Ski';
      case 'CN3XL': return 'Ski Carga';
      case 'BW3XL': return 'Ski XL';
      case 'CW3XL': return 'Ski Carga XL';
      default: return type;
    }
  }

  getLockerPicture(type) {
    return `/images/measures/locker_final_${type}.png`;
  }

  getLockerPrice(type) {
    const { prices } = this.state;
    if (!prices) return 0;
    const priceObj = prices.find(p => p.item === 'LOCKER' + type);
    return priceObj ? Number(priceObj.price) : 0;
  }

  getAvailableCount(type) {
    const { lockers } = this.state;
    if (!lockers) return 0;
    const lockerObj = lockers.find(l => l.type === type);
    return lockerObj ? lockerObj.available : 0;
  }

  formatSlotDuration(minutes) {
    const { t } = this.props;
    if (minutes >= 1440) {
      const hours = minutes / 60;
      return `${hours}h`;
    }
    if (minutes >= 60) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return mins > 0 ? `${hours}h ${mins}min` : `${hours}h`;
    }
    return `${minutes} min`;
  }

  getLockerDimensions(type) {
    // B/C = irrelevant | N = ancho 30cm, W = ancho 40cm
    // S = alto 30cm, M = 60cm, L = 90cm, XL = 120cm, 2XL = 150cm, 3XL = 190cm | fondo always 50cm
    const dims = {
      'BNS':   { ancho: 30, alto: 30,  fondo: 50 },
      'CNS':   { ancho: 30, alto: 30,  fondo: 50 },
      'BWS':   { ancho: 40, alto: 30,  fondo: 50 },
      'CWS':   { ancho: 40, alto: 30,  fondo: 50 },
      'BNM':   { ancho: 30, alto: 60,  fondo: 50 },
      'CNM':   { ancho: 30, alto: 60,  fondo: 50 },
      'BWM':   { ancho: 40, alto: 60,  fondo: 50 },
      'CWM':   { ancho: 40, alto: 60,  fondo: 50 },
      'BNL':   { ancho: 30, alto: 90,  fondo: 50 },
      'CNL':   { ancho: 30, alto: 90,  fondo: 50 },
      'BWL':   { ancho: 40, alto: 90,  fondo: 50 },
      'CWL':   { ancho: 40, alto: 90,  fondo: 50 },
      'BNXL':  { ancho: 30, alto: 120, fondo: 50 },
      'CNXL':  { ancho: 30, alto: 120, fondo: 50 },
      'BWXL':  { ancho: 40, alto: 120, fondo: 50 },
      'CWXL':  { ancho: 40, alto: 120, fondo: 50 },
      'BN2XL': { ancho: 30, alto: 150, fondo: 50 },
      'CN2XL': { ancho: 30, alto: 150, fondo: 50 },
      'BW2XL': { ancho: 40, alto: 150, fondo: 50 },
      'CW2XL': { ancho: 40, alto: 150, fondo: 50 },
      'BN3XL': { ancho: 30, alto: 190, fondo: 50 },
      'CN3XL': { ancho: 30, alto: 190, fondo: 50 },
      'BW3XL': { ancho: 40, alto: 190, fondo: 50 },
      'CW3XL': { ancho: 40, alto: 190, fondo: 50 },
    };
    return dims[type] || null;
  }

  getMinSlot() {
    const { timeConfig } = this.state;
    const slots = timeConfig?.timeSlots || [60];
    return Math.min(...slots);
  }

  getMaxTotalMinutes() {
    const { timeConfig } = this.state;
    const maxSlots = timeConfig?.maxSlots || 8;
    return this.getMinSlot() * maxSlots;
  }

  selectLockerType = (type) => {
    const minSlot = this.getMinSlot();
    this.setState({
      selectedLockerType: type,
      step: 2,
      selectedTotalMinutes: minSlot,
    }, () => {
      // On mobile the right column is stacked below — scroll it into view
      if (this.timeSelectorRef.current) {
        this.timeSelectorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  incrementTime = () => {
    const minSlot = this.getMinSlot();
    const maxTotal = this.getMaxTotalMinutes();
    const current = this.state.selectedTotalMinutes || minSlot;
    this.setState({ selectedTotalMinutes: Math.min(current + minSlot, maxTotal) });
  }

  decrementTime = () => {
    const minSlot = this.getMinSlot();
    const current = this.state.selectedTotalMinutes || minSlot;
    this.setState({ selectedTotalMinutes: Math.max(current - minSlot, minSlot) });
  }

  getTotalMinutes() {
    return this.state.selectedTotalMinutes || 0;
  }

  getTotalPrice() {
    const { selectedLockerType, selectedTotalMinutes } = this.state;
    if (!selectedLockerType || !selectedTotalMinutes) return 0;
    const basePrice = this.getLockerPrice(selectedLockerType);
    const minSlot = this.getMinSlot();
    return basePrice * (selectedTotalMinutes / minSlot);
  }

  formatTotalTime() {
    const totalMinutes = this.getTotalMinutes();
    if (totalMinutes === 0) return '--';
    const hours = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;
    if (hours === 0) return `${mins} min`;
    if (mins === 0) return `${hours}h`;
    return `${hours}h ${mins}min`;
  }

  handleContinue = () => {
    const { selectedLockerType, selectedTotalMinutes, customer, qrType, timeConfig, ticketIVA, termsLink } = this.state;
    const { zoneSelected, descriptionZone, qr, customerName, qrMode } = this.props.location.state;

    if (!selectedLockerType || !selectedTotalMinutes) return;

    const lockerPrice = this.getTotalPrice();
    const totalMinutes = selectedTotalMinutes;
    const minSlot = this.getMinSlot();
    const slotCount = Math.round(totalMinutes / minSlot);

    // Check for an existing valid session prebooking for this exact context
    const PREBOOKING_KEY = 'vacway_time_prebooking';
    const existing = (() => {
      try { return JSON.parse(sessionStorage.getItem(PREBOOKING_KEY)); } catch { return null; }
    })();
    const elapsed = existing ? (Date.now() - existing.startTimestamp) / 1000 : 0;
    const remaining = existing ? (300 - elapsed) : 0;

    if (
      existing &&
      existing.qr === String(qr) &&
      existing.zone === zoneSelected &&
      existing.selectedLocker === selectedLockerType &&
      remaining > 0
    ) {
      // Reuse existing prebooking — skip API call
      history.push('/phoneTimeView', {
        zoneSelected,
        descriptionZone,
        selectedLocker: selectedLockerType,
        lockerPrice,
        totalMinutes,
        slotMinutes: minSlot,
        slotCount,
        pricePerSlot: this.getLockerPrice(selectedLockerType),
        lockerAssigned: existing.lockerAssigned,
        lockerMatricula: existing.lockerMatricula,
        lockerCustomer: customerName || customer,
        lockerCustomerID: existing.lockerCustomerID,
        qr,
        qrType,
        qrMode,
        timeConfig,
        ticketIVA,
        termsLink,
        timeStamp: existing.startTimestamp,
      });
      return;
    }

    this.setState({ isLoading: true });

    // Prebooking - reserve a locker temporarily
    const prebookingData = {
      Qr: qr,
      Zone: zoneSelected,
      LockerSelected: selectedLockerType,
    };

    this.props.postPrebooking(prebookingData)
      .then((answer) => {
        const prebooking = answer.response.answerPrebooking;

        // Persist prebooking in session storage to avoid duplicate bookings
        sessionStorage.setItem(PREBOOKING_KEY, JSON.stringify({
          qr: String(qr),
          zone: zoneSelected,
          selectedLocker: selectedLockerType,
          lockerAssigned: prebooking.LockerAssigned,
          lockerMatricula: prebooking.LockerMatricula,
          lockerCustomerID: prebooking.LockerCustomerID || customer,
          startTimestamp: Date.now(),
        }));

        this.setState({ isLoading: false });

        history.push('/phoneTimeView', {
          zoneSelected,
          descriptionZone,
          selectedLocker: selectedLockerType,
          lockerPrice,
          totalMinutes,
          slotMinutes: minSlot,
          slotCount,
          pricePerSlot: this.getLockerPrice(selectedLockerType),
          lockerAssigned: prebooking.LockerAssigned,
          lockerMatricula: prebooking.LockerMatricula,
          lockerCustomer: customerName || customer,
          lockerCustomerID: prebooking.LockerCustomerID || customer,
          qr,
          qrType,
          qrMode,
          timeConfig,
          ticketIVA,
          termsLink,
          timeStamp: Date.now(),
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ isLoading: false, errorMessage: true });
      });
  }

  renderLockerTypes() {
    const { t } = this.props;
    const { lockers, prices } = this.state;
    const primaryColor = this.getPrimaryColor();
    const buttonStyle = this.getButtonStyle();
    const buttonText = this.props.qrData?.headerConfig?.buttonText || '#ffffff';
    const iconsColor = this.props.qrData?.headerConfig?.iconsColor || primaryColor || '#01315f';

    if (!lockers || !prices) {
      return (<div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>);
    }

    const orderedLockerKeys = [
      'BNS', 'CNS', 'BWS', 'CWS',
      'BNM', 'CNM', 'BWM', 'CWM',
      'BNL', 'CNL', 'BWL', 'CWL',
      'BNXL', 'CNXL', 'BWXL', 'CWXL',
      'BN2XL', 'CN2XL', 'BW2XL', 'CW2XL',
      'BN3XL', 'CN3XL', 'BW3XL', 'CW3XL',
    ];

    const availableLockers = orderedLockerKeys
      .map(key => lockers.find(l => l.type === key))
      .filter(l => l && l.available > 0);

    if (availableLockers.length === 0) {
      return (
        <div className="time-sold-out">
          <img src="/images/locker_BNS.png" alt="Sold Out" />
          <h4>{t('No hay taquillas disponibles en esta zona')}</h4>
        </div>
      );
    }

    return (
      <div className="time-locker-types">
        {availableLockers.map(({ type, available }) => (
          <div
            key={type}
            className={`time-locker-card ${this.state.selectedLockerType === type ? 'time-locker-card-selected' : ''}`}
            style={this.state.selectedLockerType === type ? { ...buttonStyle, border: 'none' } : {}}
            onClick={() => this.selectLockerType(type)}
          >
            <button
              className="time-measure-badge"
              onClick={(e) => { e.stopPropagation(); this.setState({ measureModal: true, measureType: type }); }}
              title={t('Ver medidas')}
            ><Info size={14} strokeWidth={2.5} /></button>
            <div className="time-locker-img-wrap">
              <img src={this.getLockerPicture(type)} alt={type} className="time-locker-img" />
            </div>
            <div className="time-locker-info">
              <h5>{this.getLockerType(type)}</h5>
              {(() => {
                const d = this.getLockerDimensions(type);
                return d ? (
                  <>
                    <span className="time-locker-dims">{d.ancho} × {d.alto} × {d.fondo} cm</span>
                    <span className="time-locker-dims-label">ancho × alto × fondo</span>
                  </>
                ) : null;
              })()}
            </div>
            <div className="time-locker-card-right">
              <span className="time-locker-desde">{t('DESDE')}</span>
              <p className="time-locker-price">
                {this.getLockerPrice(type).toFixed(2)} {currencySymbol()} <span className="time-locker-per-slot">/ {this.formatSlotDuration(this.getMinSlot())}</span>
              </p>
              <span className="time-locker-avail">{available} {t('disponibles')}</span>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderTimeSelector() {
    const { t } = this.props;
    const { timeConfig, selectedTotalMinutes } = this.state;
    const primaryColor = this.getPrimaryColor();
    const buttonStyle = this.getButtonStyle();
    const iconsColor = this.props.qrData?.headerConfig?.iconsColor || primaryColor || '#01315f';

    if (!timeConfig) return null;

    const slots = timeConfig.timeSlots || [60, 120, 240];
    const minSlot = this.getMinSlot();
    const maxTotalMinutes = this.getMaxTotalMinutes();
    const currentMinutes = selectedTotalMinutes || minSlot;

    return (
      <div className="time-time-selector">
        <h4 className="time-section-title">{t('¿Cuánto tiempo necesitas?')}</h4>

        <div className="time-time-slots">
          {slots.map((minutes) => (
            <button
              key={minutes}
              className={`time-time-slot ${selectedTotalMinutes === minutes ? 'time-time-slot-active' : ''}`}
              style={selectedTotalMinutes === minutes ? buttonStyle : {}}
              onClick={() => this.setState({ selectedTotalMinutes: minutes })}
            >
              {this.formatSlotDuration(minutes)}
            </button>
          ))}
        </div>

        <h4 className="time-section-title time-custom-label">{t('O elige la duración exacta:')}</h4>
        <div className="time-qty-controls">
          <button
            className="time-qty-btn"
            onClick={this.decrementTime}
            disabled={selectedTotalMinutes <= minSlot}
          >−</button>
          <span className="time-qty-value">{this.formatSlotDuration(currentMinutes)}</span>
          <button
            className="time-qty-btn"
            onClick={this.incrementTime}
            disabled={currentMinutes >= maxTotalMinutes}
          >+</button>
        </div>

        {selectedTotalMinutes && (
          <div className="time-fade-in">
            <div className="time-summary-card" style={{ borderColor: iconsColor }}>
              <div className="time-summary-divider"></div>
              <div className="time-summary-row">
                <span>{t('Tiempo total')}</span>
                <strong>{this.formatTotalTime()}</strong>
              </div>
              <div className="time-summary-row">
                <span>{t('Cortesía')}</span>
                <strong>+{timeConfig.courtesyTime || 5} min</strong>
              </div>
              <div className="time-summary-divider"></div>
              <div className="time-summary-row time-summary-total">
                <span>{t('Precio total')}</span>
                <strong>{this.getTotalPrice().toFixed(2)} {currencySymbol()}</strong>
              </div>
            </div>
            <button
              className="time-continue-btn"
              style={buttonStyle}
              onClick={this.handleContinue}
              disabled={this.state.isLoading}
            >
              {this.state.isLoading ? (
                <div className="spinner-border spinner-border-sm text-light" role="status"></div>
              ) : (
                t('CONTINUAR')
              )}
            </button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const { step, selectedLockerType, errorMessage } = this.state;
    const { descriptionZone } = this.props.location.state;

    return (
      <div className="timeBackground">
        <AppTimeHeader />
        <div className="time-page-wrap">
          <div className="time-content time-locker-selector-wide">
            <div className="time-page-header">
              <div className="time-page-header-icon" style={this.getButtonStyle()}>
                <Package size={24} strokeWidth={2} />
              </div>
              <div className="time-page-header-text">
                <h2>{descriptionZone}</h2>
                <p>{t('Elige el tamaño y la duración de tu alquiler')}</p>
              </div>
              <span className="time-page-header-step">2 / 5</span>
            </div>

            <div className="time-locker-selector-cols">
              {/* Left column: locker types */}
              <div className="time-locker-col-left">
                <h4 className="time-section-title">{t('Selecciona el tamaño de taquilla')}</h4>
                {this.renderLockerTypes()}
              </div>

              {/* Right column: time + summary */}
              <div ref={this.timeSelectorRef} className={`time-locker-col-right ${!selectedLockerType ? 'time-col-locked' : ''}`}>
                <div className={selectedLockerType ? 'time-fade-in' : ''}>
                  {this.renderTimeSelector()}
                </div>
                {!selectedLockerType && (
                  <div className="time-col-locked-hint">
                    <Package size={28} strokeWidth={1.5} />
                    <p>{t('Selecciona primero un tamaño de taquilla')}</p>
                  </div>
                )}
              </div>
            </div>

            {errorMessage && (
              <div className="time-error">
                <p>{t('Ha ocurrido un error. Por favor, inténtalo de nuevo.')}</p>
              </div>
            )}

          </div>
        </div>
        <StepBarTime step={2} />

        {/* Locker Dimensions Modal */}
        {(() => {
          const { measureModal, measureType } = this.state;
          const dims = measureType ? this.getLockerDimensions(measureType) : null;
          const primaryColor = this.getPrimaryColor();
          return (
            <Modal isOpen={measureModal} toggle={() => this.setState({ measureModal: false })} centered>
              <ModalBody className="time-modal time-measure-modal">
                <h4 className="time-measure-modal-title">
                  {measureType ? this.getLockerType(measureType) : ''}
                </h4>
                <img
                  src={measureType ? this.getLockerPicture(measureType) : ''}
                  alt={measureType}
                  className="time-measure-modal-img"
                />
                {dims && (
                  <div className="time-measure-dims">
                    <div className="time-measure-dim">
                      <span className="time-measure-dim-icon">↔</span>
                      <div>
                        <span className="time-measure-dim-label">{t('Ancho')}</span>
                        <strong className="time-measure-dim-value">{dims.ancho} cm</strong>
                      </div>
                    </div>
                    <div className="time-measure-dim">
                      <span className="time-measure-dim-icon">↕</span>
                      <div>
                        <span className="time-measure-dim-label">{t('Alto')}</span>
                        <strong className="time-measure-dim-value">{dims.alto} cm</strong>
                      </div>
                    </div>
                    <div className="time-measure-dim">
                      <span className="time-measure-dim-icon">⇔</span>
                      <div>
                        <span className="time-measure-dim-label">{t('Fondo')}</span>
                        <strong className="time-measure-dim-value">{dims.fondo} cm</strong>
                      </div>
                    </div>
                  </div>
                )}
                <button
                  className="time-modal-btn time-btn-cancel"
                  onClick={() => this.setState({ measureModal: false })}
                >
                  {t('Cerrar')}
                </button>
              </ModalBody>
            </Modal>
          );
        })()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: true,
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  fetchLockers: bindActionCreators(fetchTimeDisponibility, dispatch),
  postPrebooking: bindActionCreators(postTimePrebooking, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(LockerSelectorTimeView));
